import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import tourParticipantCustomFieldsApi from '@/features/dashboard/tourCustomFields/api/tourParticipantCustomFieldsApi.ts';
import { tourParticipantCustomFieldsApiQueryKeys } from '@/features/dashboard/tourCustomFields/api/tourParticipantCustomFieldsApi.queryKeys.ts';
import { customFieldDefinitionMapper } from '@/features/dashboard/tourCustomFields/types/BaseCustomFieldDefinitionDto.mapper.ts';
import { CustomFieldFormData } from '@/features/dashboard/tourCustomFields/schemas/_customFieldSchema.ts';
import CustomFieldDefinitionDto from '@/features/dashboard/tourCustomFields/types/_CustomFieldDefinitionDto.ts';

export default function useUpdateCustomField(tourId: string, fieldId: string) {
  const queryClient = useQueryClient();

  const updateCustomField = async (
    fieldDefForm: CustomFieldFormData,
  ): Promise<void> => {
    const fieldDefDto = customFieldDefinitionMapper.fromFormToDto(fieldDefForm);

    const dto = {
      ...fieldDefDto,
      id: fieldId,
    } as CustomFieldDefinitionDto;

    return await tourParticipantCustomFieldsApi.updateField(
      tourId,
      fieldId,
      dto,
    );
  };

  return useMutation({
    mutationFn: updateCustomField,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: tourParticipantCustomFieldsApiQueryKeys.allForTour(tourId),
      });
    },
    onError: (error: Error) => {
      toast('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas zapisywania danych.',
      });
    },
  });
}
